
import { UblS3UploadedFile } from "@/plugins/ubl/models/ubl-archive-file";
import { UblService } from "@/plugins/ubl/services/ubl-service";
import Vue from "vue";
//import AppCreateUblArchiveModalWrapper from "./CreateUblArchiveModalWrapper.vue";
import AppUblSendModal from "../bookkeeping/UblSendModal.vue";

export default Vue.extend({
	props: {
		createdArchive: {
			type: Object as () => UblS3UploadedFile,
			required: true
		},
		isPurchase: Boolean,
	},
	computed: {
		publicLink(): string {
			return this.createdArchive.getPublicLink();
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async markSent(to:string) {
			try {
				await UblService.markArchiveSent(this.createdArchive, to);
				this.$emit("sent");
			} catch (err) {

			}
		},
		async download() {
			await UblService.downloadArchive(this.createdArchive);
		},
		copyLink() {
			let vueInput = this.$refs.input as any;
			if (!vueInput) return;
			let input = vueInput.inputElement as HTMLInputElement;
			input.select();
			document.execCommand("copy");
			this.$wf.notify(this.$ct("coppied"), "success", 3000, "check");
		}
	},
	components: {
		//AppCreateUblArchiveModalWrapper,
		AppUblSendModal
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
